module.exports = __webpack_public_path__ + "img/rascrut-4.3f4cadd5.webp";